import { PhotoOrderFactory } from './photoOrderFactory';

import type {
  PhotoOrderEntity,
  PhotoOrderPropsPub,
  PhotoOrderPropsPvt,
} from './photoOrderEntity';
import type { PhotoOrderIRepository } from './photoOrderIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { PhotoOrderJsonPub, PhotoOrderJsonPvt } from '@/types/domain/photo/entities/photoOrderEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class PhotoOrderRepository extends AppsyncRepository<
  PhotoOrderEntity,
  PhotoOrderPropsPvt,
  PhotoOrderJsonPvt,
  PhotoOrderPropsPub,
  PhotoOrderJsonPub
> implements PhotoOrderIRepository {
  private factory = new PhotoOrderFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryPhotoPhotoOrderEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
